import KiteSwitch from './KiteSwitch';
export default KiteSwitch;
